import DOMPurify from "dompurify";

// Allowed HTML tags and attributes for comments
const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "ul",
  "ol",
  "li",
  "h1",
  "h2",
  "a",
];

const ALLOWED_ATTR = ["href", "target", "rel"]; // keep links safe

export function sanitizeHtml(html) {
  if (!html) return "";
  let clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    USE_PROFILES: { html: true },
    RETURN_TRUSTED_TYPE: false,
  });
  // Post-process anchors to enforce safe link behavior
  try {
    const container = document.createElement("div");
    container.innerHTML = clean;
    container.querySelectorAll("a[href]").forEach((a) => {
      a.setAttribute("target", "_blank");
      a.setAttribute("rel", "noopener noreferrer nofollow");
    });
    clean = container.innerHTML;
  } catch (_) {}
  return clean;
}

// Normalize input that might be plain text (with newlines) into basic HTML then sanitize
export function normalizeCommentHtml(input) {
  const raw = typeof input === "string" ? input : "";
  const hasTags = /<[^>]+>/.test(raw);
  const html = hasTags ? raw : raw.replace(/\n/g, "<br>");
  return sanitizeHtml(html);
}

export function isHtmlEmpty(html) {
  if (!html) return true;
  const textOnly = html.replace(/<(.|\n)*?>/g, "").trim();
  return textOnly.length === 0;
}

// Extract plain text from HTML, stripping all tags and decoding entities
export function htmlToPlainText(html) {
  if (!html) return "";
  const container = document.createElement("div");
  container.innerHTML = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });
  return container.textContent || container.innerText || "";
}
